<template>
  <button
    type="button"
    data-cy="deal-activity-filter-row"
    class="flex w-full items-center justify-between rounded px-3 py-2 text-xs hover:bg-grey-hover"
    :class="{ 'bg-grey-hover': isActive }"
    @click.stop="$emit('click')"
  >
    <span class="font-normal text-headline-new">{{ label }}</span>
    <span class="flex min-w-0 items-center space-x-2">
      <span v-if="summary" class="text-label" :title="summary">
        {{ summary }}
      </span>
      <icon-base
        :icon="IconArrowRight"
        height="10"
        width="10"
        view-box="0 0 16 16"
        class="shrink-0 text-label"
      />
    </span>
  </button>
</template>

<script setup lang="ts">
import IconArrowRight from "@/components/icons/IconArrowRight.vue";
import IconBase from "@/components/ui/IconBase.vue";

defineProps<{
  label: string;
  summary?: string;
  isActive?: boolean;
}>();

defineEmits<{
  click: [];
}>();
</script>
